import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Card,
  message,
  Spin,
  List,
  Popconfirm,
  Typography,
} from "antd";
import {
  HEADERS_EXPORT_BEN,
  POST_EXPENSE_LIST,
  POST_UPDATE_BILL,
} from "../../../../API/apiUrls";
import axios from "axios";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import DateCustom from "../../../../../hook/DateCustom";
import CurrencyFormat from "../../../../../hook/CurrencyFormat";
import EditAdvancePaymentDetail from "./EditAdvancePaymentDetail";
import ThaiDatePicker from "../../../../../hook/ThaiDatePicker";

const { Text } = Typography;

const CreateAdvanePayment = ({
  open,
  close,
  dataDefault,
  funcUpdateStatus,
  company,
}) => {
  const [form] = Form.useForm();
  const [convertDateThai] = DateCustom();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const { TextArea } = Input;
  const [isEditModal, setIsEditModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataPropertyList, setDataPropertyList] = useState([]);
  const [editPayment, setEditPayment] = useState();
  const [totalAll, setTotalAll] = useState(0);
  const [dataLoadLawSuit, setDataLoadLawSuit] = useState([]);

  // ✅ ฟังก์ชันดึงค่าจาก workExpenseList ตาม expenseTypeId
  const getExpenseValue = useCallback((workExpenseList, expenseTypeId) => {
    if (!workExpenseList || !Array.isArray(workExpenseList)) return 0;

    const expense = workExpenseList.find(
      (item) => item.expenseTypeId === expenseTypeId,
    );

    return expense ? Number(expense.NETPAY || 0) : 0;
  }, []);

  // ✅ Expense Type IDs
  const EXPENSE_TYPE = {
    DELIVERY_ENFORCE: 5, // วางคำบังคับ
  };

  const loadData = useCallback(async () => {
    // ✅ เช็คว่ามีข้อมูลก่อน
    if (!dataDefault || dataDefault.length === 0) {
      message.warning("ไม่มีข้อมูลที่เลือก");
      return;
    }

    setLoading(true);
    const controller = new AbortController();

    try {
      // ✅ ดึง lawsuitId จากทุก item และกรอง undefined/null ออก
      const lawsuitIds = dataDefault
        .map((item) => item.lawsuitId)
        .filter((id) => id !== undefined && id !== null);

      console.log("📤 Sending lawsuitIds:", lawsuitIds);

      // ✅ เช็คว่ามี lawsuitId หรือไม่
      if (lawsuitIds.length === 0) {
        message.warning("ไม่พบ lawsuitId ในข้อมูลที่เลือก");
        setLoading(false);
        return;
      }

      const lawsuitRes = await axios.post(
        POST_EXPENSE_LIST,
        { lawsuitId: lawsuitIds },
        {
          headers: HEADERS_EXPORT_BEN,
          signal: controller.signal,
        },
      );

      // Handle lawsuit response
      if (lawsuitRes?.data && Array.isArray(lawsuitRes.data)) {
        console.log("✅ lawsuitRes:", lawsuitRes.data);
        setDataLoadLawSuit(lawsuitRes.data);
        setDataPropertyList(lawsuitRes.data);
      } else {
        throw new Error("ไม่พบข้อมูลคดี");
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("❌ Error loading data:", error);
        const errorMsg = error.response?.data?.message || error.message;
        message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
      }
    } finally {
      setLoading(false);
    }

    return () => controller.abort();
  }, [dataDefault]);

  useEffect(() => {
    if (open) {
      loadData();
    }
  }, [open, loadData]);

  // ✅ คำนวณยอดรวมทั้งหมด
  useEffect(() => {
    const total = dataPropertyList.reduce((sum, item) => {
      const deliveryEnforce = getExpenseValue(
        item.workExpenseList,
        EXPENSE_TYPE.DELIVERY_ENFORCE,
      );

      return sum + deliveryEnforce;
    }, 0);

    setTotalAll(total);
  }, [dataPropertyList, getExpenseValue, EXPENSE_TYPE]);

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
  };

  const sendData = async (payload) => {
    setLoading(true);
    console.log("📤 Sending payload:", payload);

    try {
      if (!payload || !payload.lawsuitId || payload.lawsuitId.length === 0) {
        message.warning("ไม่พบข้อมูล lawsuitId");
        setLoading(false);
        return;
      }

      if (!payload.workExpenseList || payload.workExpenseList.length === 0) {
        message.warning("ไม่พบรายการค่าใช้จ่าย");
        setLoading(false);
        return;
      }

      const response = await axios.post(POST_UPDATE_BILL, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (response.status === 200 || response.status === 201) {
        console.log("✅ Response:", response.data);
        message.success("บันทึกข้อมูลสำเร็จ");

        funcUpdateStatus?.();

        handleCancel();
      } else {
        throw new Error("การบันทึกข้อมูลไม่สำเร็จ");
      }
    } catch (error) {
      console.error("❌ Error:", error);
      const errorMsg = error.response?.data?.message || error.message;
      message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item, index) => {
    console.log("item", item, index);
    setEditPayment(dataPropertyList[index]);
    setIsEditModal(true);
  };

  const handleDelete = (index) => {
    Modal.confirm({
      title: "ต้องการลบสัญญานี้ใช่หรือไม่​?",
      okText: "ยืนยัน",
      cancelText: "ปิด",
      onOk: () => {
        console.log("delete--->", index);
        setDataPropertyList((prevData) =>
          prevData.filter((_, i) => i !== index),
        );
      },
    });
  };

  const onFinish = (values) => {
    console.log("values", values);
    console.log("dataPropertyList", dataPropertyList);

    const lawsuitIds = dataPropertyList
      .map((item) => item.lawsuitId)
      .filter((id) => id !== undefined && id !== null);

    // ✅ รวบรวม loanId ทั้งหมด
    const loanIds = dataPropertyList
      .map((item) => item.loanId)
      .filter((id) => id !== undefined && id !== null);

    // ✅ รวบรวม workExpenseList ids (เฉพาะที่มี NETPAY > 0)
    const workExpenseIds = [];
    dataPropertyList.forEach((lawsuit) => {
      if (lawsuit.workExpenseList && Array.isArray(lawsuit.workExpenseList)) {
        lawsuit.workExpenseList.forEach((expense) => {
          const amount = Number(expense.NETPAY || 0);
          if (amount > 0 && expense.id && expense.expenseTypeId === 5) {
            workExpenseIds.push(expense.id);
          }
        });
      }
    });
    console.log(workExpenseIds);

    // ✅ สร้าง payload
    const payload = {
      COMPANY_ID: dataDefault[0].COMPANY_ID,
      NETPAY: totalAll,
      userId: userId,
      payamtMark: values.memo,
      lawsuitId: lawsuitIds,
      loanId: loanIds,
      workExpenseList: workExpenseIds,
      advaneType: 2, //ชั้นศาล
    };

    console.log("📤 Payload:", payload);

    // ตรวจสอบข้อมูลก่อนส่ง
    if (lawsuitIds.length === 0) {
      message.error("ไม่พบ lawsuitId");
      return;
    }

    if (loanIds.length === 0) {
      message.error("ไม่พบ loanId");
      return;
    }

    if (workExpenseIds.length === 0) {
      message.error("ไม่พบรายการค่าใช้จ่าย");
      return;
    }

    // ส่งข้อมูล
    sendData(payload);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบ");
  };

  const onChangeInputInvestigateDate = (date, dateString) => {
    console.log(date);
    console.log(dateString);
  };

  const onChangeInputMemo = (value) => {
    console.log(value);
  };

  const confirm = () => {
    form.submit();
  };

  const cancel = () => {
    message.success("ยกเลิกทำรายการ");
  };

  // ✅ Callback จาก Modal
  const handleModalCallback = useCallback(() => {
    console.log("📥 Callback from modal");
    loadData();
  }, [loadData]);

  // ✅ ฟังก์ชันคำนวณยอดรวมต่อสัญญา
  const calculateItemTotal = useCallback(
    (item) => {
      const deliveryEnforce = getExpenseValue(
        item.workExpenseList,
        EXPENSE_TYPE.DELIVERY_ENFORCE,
      );

      return deliveryEnforce;
    },
    [getExpenseValue, EXPENSE_TYPE],
  );

  // ✅ ฟังก์ชันแสดงชื่อเต็ม
  const getFullName = useCallback((item) => {
    const title = item.SNAM || "";
    const firstName = item.NAME1 || "";
    const lastName = item.NAME2 || "";

    return `${title}${firstName} ${lastName}`.trim();
  }, []);

  const formDataSet = () => {
    return (
      <Form
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 14 }}
        form={form}
        layout="horizontal"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          memo: null,
          dateWithdraw: dayjs(),
        }}
      >
        <Form.Item
          label="วันที่ทำรายการ"
          name="dateWithdraw"
          rules={[
            {
              required: true,
              message: "กรุณาเลือกวันที่ทำรายการ",
            },
          ]}
        >
          <ThaiDatePicker
            onChange={onChangeInputInvestigateDate}
            placeholder="เลือกวันที่"
          />
        </Form.Item>

        <Form.Item
          label="สัญญาที่ต้องการเบิก"
          name="contnoWithdraw"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
        >
          <List
            size="small"
            itemLayout="horizontal"
            dataSource={dataPropertyList}
            renderItem={(item, index) => {
              const deliveryEnforce = getExpenseValue(
                item.workExpenseList,
                EXPENSE_TYPE.DELIVERY_ENFORCE,
              );
              const itemTotal = calculateItemTotal(item);

              return (
                <List.Item
                  actions={[
                    <Link
                      key="list-loadmore-edit"
                      onClick={() => handleEdit(item, index)}
                    >
                      แก้ไข
                    </Link>,
                    <Link
                      key="list-loadmore-more"
                      style={{ color: "red" }}
                      onClick={() => handleDelete(index)}
                    >
                      ลบ
                    </Link>,
                  ]}
                >
                  <List.Item.Meta
                    title={
                      <Link onClick={() => handleEdit(item, index)}>
                        {`(${index + 1}). ${
                          item?.CONTNO || "-"
                        } - ${getFullName(item)}`}
                      </Link>
                    }
                    description={
                      <div style={{ fontSize: "13px" }}>
                        <Text type="secondary">
                          • ค่าส่งหมาย: {currencyFormatPoint(deliveryEnforce)}{" "}
                          บาท
                        </Text>
                        <br />

                        <Text strong style={{ color: "#1890ff" }}>
                          รวม: {currencyFormatPoint(itemTotal)} บาท
                        </Text>
                      </div>
                    }
                  />
                </List.Item>
              );
            }}
          />
        </Form.Item>

        <Form.Item label="ยอดเบิกทั้งสิ้น" name="totalAll">
          <Text
            strong
            style={{
              fontSize: "18px",
              color: totalAll > 50000 ? "red" : "green",
            }}
          >
            {currencyFormatPoint(totalAll)} บาท
          </Text>
          {totalAll > 50000 && (
            <>
              <br />
              <Text type="danger" style={{ fontSize: "13px" }}>
                ⚠️ เกินวงเงินกำหนด {currencyFormatPoint(totalAll - 50000)} บาท
              </Text>
            </>
          )}
        </Form.Item>

        <Form.Item label="หมายเหตุ" name="memo">
          <TextArea
            rows={4}
            onChange={(e) => onChangeInputMemo(e.target.value)}
            placeholder="ระบุหมายเหตุเพิ่มเติม (ถ้ามี)"
            maxLength={500}
            showCount
          />
        </Form.Item>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            onClick={handleCancel}
            style={{ marginRight: "20px" }}
            size="large"
          >
            ปิด
          </Button>
          <Popconfirm
            placement="topLeft"
            title="บันทึกการเบิกทดรองคำฟ้อง"
            description={
              totalAll > 50000
                ? `⚠️ มียอดเบิกเกินกำหนด ${currencyFormatPoint(
                    totalAll - 50000,
                  )} บาท ท่านต้องการยืนยันการทำรายการหรือไม่?`
                : `ยอดเบิกทั้งสิ้น ${currencyFormatPoint(
                    totalAll,
                  )} บาท - ยืนยันหรือไม่?`
            }
            onConfirm={confirm}
            onCancel={cancel}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
          >
            <Button type="primary" size="large">
              บันทึก
            </Button>
          </Popconfirm>
        </div>
      </Form>
    );
  };

  return (
    <>
      <Modal
        title="สร้างรายการเบิกเงินทดรองจ่าย"
        open={open}
        onCancel={handleCancel}
        width={900}
        footer={null}
        destroyOnHidden
      >
        <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
          <Card>{formDataSet()}</Card>
        </Spin>
      </Modal>

      {isEditModal && (
        <EditAdvancePaymentDetail
          open={isEditModal}
          close={setIsEditModal}
          dataDefault={editPayment}
          funcUpdateStatus={handleModalCallback}
        />
      )}
    </>
  );
};

export default CreateAdvanePayment;
